import styles from './Price.module.scss'

export const Price: React.FC = () => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    const targetId = e.currentTarget.getAttribute('href')?.replace('#', '')
    if (targetId) {
      const targetElement = document.getElementById(targetId)
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <div className={styles.price_container}>
      <div className={styles.main_container}>
        <p className={styles.title}>参考価格</p>
        <div className={styles.middle_container}>
          <div className={styles.tco_container}>
            <div className={styles.price_title_container}>
              <p className={styles.price_title}>TCO（総所有コスト）の試算例</p>
            </div>
            <div className={styles.price_per_month_container}>
              <p className={styles.price_text}>202.84</p>
              <p className={styles.price_per_month_text}>USD/月〜</p>
            </div>
          </div>
          <p className={styles.form_text}>
            詳細な料金に関しては、
            <a href="#contact" className={styles.form_text_link} onClick={handleClick}>
              フォームからお問い合わせ
            </a>
            ください。
          </p>
        </div>
      </div>
    </div>
  )
}
